import Decimal from 'decimal.js';
import { useIntl } from 'react-intl';

import { Currency } from '../../types/currency';
import { CurrencyDropdown } from './CurrencyDropdown';
import { Slider } from './Slider';
import { SLIDER_MIDPOINT } from '../utils/calculatorConfig';
import { t } from '../utils/translate';
import styles from './InputRow.module.less';

interface Props {
  value: string;
  currency: Currency;
  currencies: Currency[];
  loanBig: Decimal;
  minLoan: Decimal;
  maxLoan: Decimal;
  onValueChange: (raw: string) => void;
  onBlur: () => void;
  onSliderChange: (next: Decimal) => void;
  onCurrencyChange: (next: Currency) => void;
  autoFocus?: boolean;
}

export function LoanAmountRow({
  value,
  currency,
  currencies,
  loanBig,
  minLoan,
  maxLoan,
  onValueChange,
  onBlur,
  onSliderChange,
  onCurrencyChange,
  autoFocus,
}: Props) {
  const intl = useIntl();
  const mid = SLIDER_MIDPOINT[currency];

  return (
    <div className={styles.row}>
      <label className={styles.label}>
        {t(intl, 'calculator.loanAmount')}
      </label>
      <div className={styles.innerRow}>
        <div className={styles.inputWrap}>
          <input
            type="text"
            inputMode="decimal"
            className={styles.amountInput}
            value={value}
            onChange={e => onValueChange(e.target.value)}
            onBlur={onBlur}
            aria-label={t(intl, 'calculator.loanAmount')}
            autoFocus={autoFocus}
          />
          <CurrencyDropdown value={currency} options={currencies} onChange={onCurrencyChange} />
        </div>
        <Slider
          value={loanBig}
          min={minLoan}
          mid={mid}
          max={maxLoan}
          ariaLabel={t(intl, 'calculator.loanAmountSlider')}
          onValueChange={onSliderChange}
        />
      </div>
    </div>
  );
}
